<div class="universal-notes-rich-text" (click)="onTreatmentPlanNotesClick($event)">
  <div class="universal-notes-rich-text" [ngClass]="{'universal-notes-rich-text-wrapper' : !isFormDisabled,'editable-parameter-wrapper': !universalNotesData}">
      <div [ngClass]="{'universal-notes-text-highlight': isNoteChanged}" *ngIf="universalNotesData">
        <div class="ql-editor" [innerHTML]="universalNotesData"></div>
      </div>
      <div [ngClass]= "universalNotesData?'universal-notes-rich-text':'edit-no-text'">
        <span *ngIf="!universalNotesData"><i>Click to edit...</i></span>
      </div>
      <div class="universal-notes-rich-text">
        <span class="glyphicon glyphicon-pencil universal-notes-edit-icon"></span>
      </div>
  </div>
</div>
